export default __webpack_public_path__ + "6ac317f14cb2df21b813a778aaff380a.svg";